import { useEffect, useState } from "react";
import moment from "moment";
import { callApi } from "../../../ApiHelper/ApiHelper";
import { apiUrl } from "../../../ApiHelper/ApiUrl";
import { toast } from "react-toastify";
import MainHeading from "../../../components/comman/MainHeading";
import CommonTable from "../../../components/comman/CommonTable";
import AddWfhModal from "./AddWfhModal";

export default function MyWfh() {
  const [modalOpen, setModalOpen] = useState(false);
  const [pageStates, setPageStates] = useState({
    currentPage: 1,
    pageSize: 10,
    count: 0,
    totalPages: 1,
    tableLoader: false,
    wfhList: []
  });

  const getMyWfhRequests = async () => {
    try {
      setPageStates((prev) => ({ ...prev, tableLoader: true }));
      const query = `pageNumber=${pageStates.currentPage}&pageSize=${pageStates.pageSize}&myWfhRequest=true`;
      const res = await callApi(`${apiUrl.get_wfh}${query}`);
      const rawRows = res?.data?.wfhRequest || res?.data?.rows || [];
      const formattedData = rawRows.map((item) => ({
        ...item,
        startDateFormatted: item?.startDate ? moment(item.startDate).format("DD/MM/YYYY") : "--",
        endDateFormatted: item?.endDate ? moment(item.endDate).format("DD/MM/YYYY") : "--",
        wfhStatus: item?.status
      }));

      setPageStates((prev) => ({
        ...prev,
        tableLoader: false,
        wfhList: formattedData,
        count: res?.data?.count || formattedData.length,
        totalPages: res?.data?.totalPages || 1
      }));
    } catch (err) {
      setPageStates((prev) => ({ ...prev, tableLoader: false }));
      toast.error(err?.message || "Error fetching my WFH requests");
    }
  };

  useEffect(() => {
    getMyWfhRequests();
  }, [pageStates.currentPage, pageStates.pageSize]);

  const TableHeading = [
    { value: "index", label: "SR NO." },
    { value: "startDateFormatted", label: "From" },
    { value: "endDateFormatted", label: "To" },
    { value: "reason", label: "Reason" },
    { value: "wfhStatus", label: "Status" }
  ];

  return (
    <div className="content p-4">
      <MainHeading
        title="My Work From Home (WFH) Requests"
        buttonText="Apply WFH"
        clickHandler={() => setModalOpen(true)}
      />

      <div className="card mt-4">
        <div className="card-body">
          <CommonTable
            TableHeading={TableHeading}
            TableData={pageStates.wfhList}
            currentPage={pageStates.currentPage}
            PageChangeHandler={(page) => setPageStates((prev) => ({ ...prev, currentPage: page }))}
            isLoading={pageStates.tableLoader}
            totalPages={pageStates.totalPages}
            count={pageStates.count}
            handleChangePageSize={(size) => setPageStates((prev) => ({ ...prev, pageSize: size }))}
            pageSize={pageStates.pageSize}
          />
        </div>
      </div>

      <AddWfhModal isOpen={modalOpen} toggle={() => setModalOpen(!modalOpen)} refreshData={getMyWfhRequests} />
    </div>
  );
}
